import React, { memo, forwardRef, useMemo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { generateSvgId } from 'src/lib/svg';

export const IconInfoContained = memo(
  forwardRef((props, ref) => {
    const svgId = useMemo(() => generateSvgId(), []);

    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 12 12"
        data-fill-none
      >
        <g clipPath={`url(#${svgId})`}>
          <path
            d="M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z"
            fill="white"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.99992 7.99992H6.66659C6.48979 7.99992 6.32019 7.9297 6.19516 7.80467C6.07014 7.67965 5.99992 7.51005 5.99992 7.33325V5.66659C5.99992 5.57819 5.96481 5.49339 5.90227 5.4309C5.83979 5.36836 5.75499 5.33325 5.66659 5.33325H5.33325"
            stroke="currentColor"
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M5.83341 4.00008C5.74137 4.00008 5.66675 3.92546 5.66675 3.83341C5.66675 3.74137 5.74137 3.66675 5.83341 3.66675"
            stroke="currentColor"
            strokeWidth="1.2"
          />
          <path
            d="M5.83325 4.00008C5.9253 4.00008 5.99992 3.92546 5.99992 3.83341C5.99992 3.74137 5.9253 3.66675 5.83325 3.66675"
            stroke="currentColor"
            strokeWidth="1.2"
          />
        </g>

        <defs>
          <clipPath id={`url(#${svgId})`}>
            <rect
              width="12"
              height="12"
              fill="white"
            />
          </clipPath>
        </defs>
      </SvgIcon>
    );
  })
);
